






































import { Vue } from "vue-property-decorator";
import AppLayout from "@/components/app-layout.vue";
import store from "@/store";
import { mapGetters } from "vuex";
import IndividusScrollAlphabet from "./components/individus-scrollalphabet.vue";
import IndividusList from "./components/individus-list.vue";
import AppAdo from "@/components/app-ado.vue";
import { Individu } from "@/models/Individu";
import { SHOW_LOADING, CLOSE_LOADING } from "../../store/types";
export default Vue.extend({
  beforeRouteEnter(from, to, next) {
    store.dispatch(SHOW_LOADING);
    store.dispatch("individus/fetchDataForFilter");
    store
      .dispatch("individus/fetchListIndividus", "etablissement")
      .then(() => {
        store.dispatch(CLOSE_LOADING);
        next();
      })
      .catch((error: any) => {
        store.dispatch(CLOSE_LOADING);
        next("/erreurs/" + error);
      });
  },
  components: {
    AppLayout,
    IndividusScrollAlphabet,
    IndividusList,
    AppAdo
  },
  data() {
    return {
      alphabet: [...Array(26)]
        .map((_, y) => String.fromCharCode(y + 65))
        .join(""),
        filtredIndividus : this.$route.params.filtred
    };
  },
  computed: {
    ...mapGetters("pointages", [
      "getIndividusPresents","getIndividusFiltreesPresents"
    ]),
    ...mapGetters("etablissements", ["getCurrentEtablissement"])
  },
  methods: {
    addEnfant(event: Individu) {
      store.dispatch("individus/selectIndividu", event);
    },
    defaultLogo(event: any) {
      event.target.src = require(`@/assets/logo.png`);
    },
    filtres(params: any) {
      store.dispatch("individus/filtreListIndividus", params);
    },
    closeFiltre(params: string) {
      store.dispatch("individus/closeFiltre", params);
    }
  }
});
